import React, { useState } from 'react';
import { Chip, Menu, MenuItem, Tooltip, CircularProgress, Box } from '@mui/material';
import { Check } from '@mui/icons-material';

const ColoredChipMenu = ({
  value,
  label,
  options,
  onChange,
  disabled = false,
  isSaving = false,
  chipVariant = 'filled',
  tooltip = 'Kliknij, aby zmienić',
}) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const currentOption = options.find((option) => option.value === value);
  const chipColor = currentOption?.color;
  const chipSx = currentOption?.sx;
  const displayVariant = currentOption?.variant || chipVariant;

  const handleOpen = (event) => {
    event.stopPropagation();
    if (!disabled && !isSaving) {
      setAnchorEl(event.currentTarget);
    }
  };

  const handleClose = (event) => {
    event?.stopPropagation?.();
    setAnchorEl(null);
  };

  const handleSelect = async (event, newValue) => {
    event.stopPropagation();
    handleClose();

    if (newValue !== value) {
      await onChange(newValue);
    }
  };

  return (
    <>
      <Tooltip title={disabled ? '' : tooltip}>
        <Chip
          label={
            isSaving ? (
              <CircularProgress size={14} color="inherit" />
            ) : (
              label
            )
          }
          size="small"
          {...(chipColor ? { color: chipColor } : {})}
          variant={displayVariant}
          onClick={handleOpen}
          disabled={disabled || isSaving}
          sx={{
            cursor: disabled || isSaving ? 'default' : 'pointer',
            '&:hover': disabled || isSaving ? {} : { opacity: 0.9 },
            ...chipSx,
          }}
        />
      </Tooltip>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        onClick={(event) => event.stopPropagation()}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'left' }}
        slotProps={{ paper: { sx: { mt: 0.5, minWidth: 240 } } }}
      >
        {options.map((option) => {
          const isSelected = option.value === value;

          return (
            <MenuItem
              key={option.value}
              selected={isSelected}
              onClick={(event) => handleSelect(event, option.value)}
              sx={{ gap: 1, py: 1 }}
            >
              <Chip
                label={option.label}
                size="small"
                variant={option.variant || chipVariant}
                sx={option.sx}
                {...(option.color ? { color: option.color } : {})}
              />
              <Box sx={{ flex: 1 }} />
              {isSelected && <Check fontSize="small" color="primary" />}
            </MenuItem>
          );
        })}
      </Menu>
    </>
  );
};

export default ColoredChipMenu;
